import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Container } from "@mui/system";
import auth_frame from "assets/images/auth_img.svg";
import styles from "./PrimaryAuthLayout.module.css";
import stanbic_logo from "assets/images/stanbic_logo.svg";
import useOpenSnackbar from "custom-hooks/snacbar/useOpenSnackbar";
import TTFSnackbar from "component/AppSnackbars/TTFSnackbar";
import { Link } from "react-router-dom";

function PrimaryAuthLayout({ children }) {
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
    useOpenSnackbar();

  return (
    <div className={styles.primary_auth_layout}>
      <Grid container>
        <Grid xs={12} lg={6} xl={5}>
          <Container maxWidth="md">
            <div className={`${styles.content} ${styles.scrollbar_hidden}`}>
              <div className={styles.logo}>
                <Link to="/">
                  <img src={stanbic_logo} alt="stanbic ibtc logo" />
                </Link>
              </div>
              {children}
            </div>
          </Container>
        </Grid>
        <Grid
          xs={12}
          lg={6}
          xl={7}
          sx={{
            display: {
              xs: "none",
              lg: "inline-block",
            },
          }}
        >
          <div className={styles.auth_frame_img}>
            {/* <img src={auth_frame} alt="" /> */}
          </div>
        </Grid>
      </Grid>
      <TTFSnackbar
        severity={severity}
        message={message}
        open={openToast}
        setOpen={setOpenToast}
        duration={duration}
      />
    </div>
  );
}

export default PrimaryAuthLayout;
